module.exports = __webpack_public_path__ + "img/j.3358c355.jpg";